import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

// --- ASSETS (Tận dụng lại các tài sản từ Keep Going) ---
import back from "./image/short_trek/back.png"; 
import Samu from "./image/short_trek/footer.png";
import lungcung_w from "./image/short_trek/header.png";

const TrainingCard = ({ title, desc, icon }) => (
  <div className="bg-white/90 backdrop-blur-sm p-8 rounded-[35px] shadow-lg border-b-4 border-sky-600 transition-transform hover:-translate-y-2">
    <div className="text-4xl mb-4">{icon}</div>
    <h3 className="text-xl font-black text-slate-900 uppercase mb-2">{title}</h3>
    <p className="text-sm text-slate-600 font-bold italic leading-relaxed">{desc}</p>
  </div>
);

export default function HocLeoNui() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <div className="relative min-h-screen font-sans overflow-x-hidden bg-slate-100"
         style={{ backgroundImage: `url(${back})`, backgroundAttachment: "fixed", backgroundSize: "cover" }}>
      
      <div className="absolute inset-0 bg-slate-900/60 backdrop-blur-[2px] z-0"></div>

      <div className="relative z-10 w-full max-w-6xl mx-auto px-4 md:px-10 py-16">
        
        {/* HEADER: TRUYỀN CẢM HỨNG */}
        <header className="text-center mb-16 mt-16">
          <span className="text-orange-400 font-black tracking-[0.3em] uppercase text-xs mb-4 block">Khởi đầu bản lĩnh</span>
          <h1 className="text-6xl md:text-8xl font-black text-white mb-4 tracking-tighter uppercase leading-none">
            HỌC <span className="text-sky-400 italic font-serif">LEO NÚI</span>
          </h1>
          <p className="text-lg md:text-xl text-white/90 max-w-2xl mx-auto font-light italic leading-relaxed">
            "Đừng đợi đến khi đủ giỏi mới bắt đầu. Hãy bắt đầu để trở nên giỏi hơn thông qua những bước chân thực tế."
          </p>
        </header>

        {/* KHỐI 1: TẠI SAO PHẢI THỬ THỰC TẾ? */}
        <div className="flex flex-col md:flex-row items-center gap-10 bg-white rounded-[40px] overflow-hidden shadow-2xl mb-16">
          <div className="w-full md:w-1/2 aspect-video md:aspect-square">
            <img src={lungcung_w} alt="Thực hành" className="w-full h-full object-cover" />
          </div>
          <div className="w-full md:w-1/2 p-10 md:p-16">
            <h2 className="text-3xl md:text-4xl font-black text-sky-600 mb-6 uppercase leading-none">Kiểm nghiệm & Thấu hiểu</h2>
            <div className="text-lg text-slate-700 italic font-medium space-y-4">
              <p>Trước khi mơ về biển mây Ky Quan San hay đỉnh vòm Samu kỳ ảo, bạn cần một "phép thử" cho chính mình.</p>
              <p>Chuyến Short Trek -- Nóc nhà thủ đô này được thiết kế để bạn thực hành cách điều phối nhịp thở, tìm ra những gì bạn muốn mang khi leo núi và quan trọng nhất: Lắng nghe giới hạn của cơ thể.</p>
            </div>
          </div>
        </div>

        {/* KHỐI 2: 4 KỸ NĂNG CỐT LÕI (TRONG CHUYẾN ĐI) */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-16">
          <TrainingCard 
            icon="🎒"
            title="Tiện ích"
            desc="Di chuyển đến địa điểm bằng Oto, đồ ăn vặt, balo, giày và ăn trưa trên đỉnh Hàm Lợn"
          />
          <TrainingCard 
            icon="🚶"
            title="Kỹ thuật di chuyển"
            desc="Thực hành bước đi trên các địa hình dốc, cách bảo vệ đầu gối và duy trì sức bền suốt hành trình."
          />
          <TrainingCard 
            icon="🌬️"
            title="Kiểm soát nhịp thở"
            desc="Làm chủ hơi thở để vượt qua những đoạn dốc gắt mà không bị hụt hơi hay quá tải."
          />
          <TrainingCard 
            icon="🤝"
            title="Kết nối leader"
            desc="Học cách tương tác và trân trọng những người bạn đồng hành tổ chức chuyến đi."
          />
        </div>

        {/* KHỐI 3: SHORT TREK - PHÒNG THỰC HÀNH GIỮA ĐẠI NGÀN */}
        <div className="bg-slate-900 text-white rounded-[40px] p-10 md:p-20 shadow-2xl relative overflow-hidden mb-16">
          <img src={Samu} alt="Samu" className="absolute inset-0 w-full h-full object-cover opacity-20" />
          <div className="relative z-10 text-center">
            <h2 className="text-4xl md:text-6xl font-black uppercase mb-8 italic tracking-tighter">Một ngày để thay đổi</h2>
            <div className="flex flex-wrap justify-center gap-4">
              <span className="bg-sky-600 px-6 py-2 rounded-full font-bold uppercase text-sm">Di chuyển oto</span>
              <span className="bg-orange-500 px-6 py-2 rounded-full font-bold uppercase text-sm"></span>
              <span className="bg-green-600 px-6 py-2 rounded-full font-bold uppercase text-sm">Tối đa 14 người / Đoàn</span>
            </div>
          </div>
        </div>

        {/* CTA: CHỐT DEAL TỰ HÀO */}
        <div className="text-center">
          <button 
            onClick={() => window.open("https://forms.gle/TyGV7igZEjSDJMUy9")}
            className="group inline-block w-full max-w-2xl bg-orange-500 hover:bg-white text-white hover:text-orange-500 p-8 rounded-[45px] shadow-2xl transition-all active:scale-95 border-b-8 border-orange-700"
          >
            <span className="text-3xl md:text-5xl font-black uppercase tracking-tighter block mb-2 transition-all group-hover:tracking-widest italic">
              Bắt đầu hành trình thực tế
            </span>
            <span className="text-sm font-bold uppercase tracking-widest opacity-80 italic">
              Kiểm nghiệm bản thân trước những đỉnh cao xa hơn
            </span>
          </button>
        </div>

        <footer className="mt-24 text-white/40 text-[10px] font-black tracking-[0.5em] uppercase text-center">
          Keep Going Academy — Learning by Doing — Since 2020 
        </footer>
      </div>
    </div>
  );
}